import React, { useEffect } from 'react'
import { LayerControl } from './LayerControl'
import { BoundControl } from './BoundControl'
import { MapEvents } from './MapEvents'
import { ZoomControl } from './ZoomControl'
import { useMapContext } from 'components/MapV2/MapProvider'
import { LegendControl } from '../ui/Legend'
import { MapSearch } from '../ui'
import { useMap } from 'react-leaflet'
import { FitToMarkers } from '../ui/FitToMarkers'
import { CustomFullscreen } from '../ui/CustomFullscreen'
import { MarkerBulkSelection } from './DrawControl/BulkSelection'
import SelectedMarkers from './DrawControl/SelectedMarkers'
import { getMarkerIcon } from '../ui/MapMarker/util'
import { CurrentLocation } from '../ui/CurrentLocation'

export const MapUtils: React.FC = () => {
  const { showZoom, shouldFitBoundsToMarkers, showLayers, getMapInstance, onBulkSelection } =
    useMapContext()
  const map = useMap()

  useEffect(() => {
    try {
      map && getMapInstance?.(map)

      map?.pm.setGlobalOptions({
        markerStyle: {
          icon: getMarkerIcon('ad-hoc', undefined, [11, 28]),
        },
      })
    } catch (error) {
      console.log('Error in MapUtils.tsx: getMapInstance', error)
    }
  }, [map, getMapInstance])

  return (
    <div>
      <LayerControl isActive={showLayers} />
      <BoundControl isActive={shouldFitBoundsToMarkers} />
      <ZoomControl isActive={showZoom} />
      <LegendControl />
      <MapSearch />
      <FitToMarkers />
      <CustomFullscreen />
      <CurrentLocation />
      <MapEvents />
      <MarkerBulkSelection isActive={!!onBulkSelection} />
      <SelectedMarkers isActive={!!onBulkSelection} />
    </div>
  )
}
